<template>
  <div class="page">
    <HeaderMain />

    <div class="page-content d-flex align-items-stretch">
      <div class="default-sidebar">
        <!-- Begin Side Navbar -->
        <SideBar />
        <!-- End Side Navbar -->
      </div>
      <!-- End Left Sidebar -->

      <div class="content-inner">
        <!-- Begin Content -->
        <router-view name="main"></router-view>
        <!-- End Content -->

        <FooterMain />
      </div>
    </div>
  </div>
</template>

<script>
import FooterMain from '@/components/mainpage/sections/Footer.vue';
import HeaderMain from '@/components/mainpage/sections/Header.vue';
import SideBar from '@/components/mainpage/sections/SideBar.vue';
export default {
  name: 'Main',
  components: {
    FooterMain,
    HeaderMain,
    SideBar,
  },
};
</script>
